import React from 'react'
import { CasoContextType } from './CasoContextType'

const CasoContext = React.createContext<CasoContextType|null>( null )

export default CasoContext

